import { render, staticRenderFns } from "./ConfigurazioneAgendaBoxListComponent.vue?vue&type=template&id=ecc8e8f2"
import script from "./ConfigurazioneAgendaBoxListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneAgendaBoxListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports